import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "@/components/ToastNotification";
import { api } from "@/lib/api";
import { useEffect, useState } from "react";
import { PerfilAcessoEditProps } from "./interfaces/perfil_acesso.interface";

const PerfilAcessoEdit = ({ open, onOpenChange, perfil, onSuccess }: PerfilAcessoEditProps) => {
  const [formData, setFormData] = useState({
    nome: "",
    descricao: "",
    ativo: true
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (perfil) {
      setFormData({
        nome: perfil.nome || "",
        descricao: perfil.descricao || "",
        ativo: perfil.ativo ?? true
      });
    } else {
      setFormData({
        nome: "",
        descricao: "",
        ativo: true
      });
    }
  }, [perfil, open]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        nome: formData.nome,
        descricao: formData.descricao || '',
        ativo: formData.ativo
      };

      if (perfil?.id) {
        await api.put(`/api/perfil-acesso/${perfil.id}`, payload);
        toast.success("Perfil de acesso atualizado com sucesso!");
      } else {
        await api.post("/api/perfil-acesso", payload);
        toast.success("Perfil de acesso criado com sucesso!");
      }

      onSuccess();
      onOpenChange(false);
    } catch (error: any) {
      console.error("Erro ao salvar perfil:", error);
      toast.error(error?.message || "Erro ao salvar o perfil de acesso");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => onOpenChange(false);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{perfil ? "Editar Perfil de Acesso" : "Novo Perfil de Acesso"}</DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Nome */}
          <div className="space-y-2">
            <Label htmlFor="nome">Nome *</Label>
            <Input
              id="nome"
              value={formData.nome}
              onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
              placeholder="Ex: MÉDICO, ENFERMAGEM"
              maxLength={100}
              required
            />
            <p className="text-xs text-muted-foreground">
              Nome do perfil de acesso (máximo 100 caracteres)
            </p>
          </div>

          {/* Descrição */}
          <div className="space-y-2">
            <Label htmlFor="descricao">Descrição</Label>
            <Textarea
              id="descricao"
              value={formData.descricao}
              onChange={(e) => setFormData({ ...formData, descricao: e.target.value })}
              placeholder="Descrição do perfil de acesso"
              rows={4}
              maxLength={255}
            />
            <p className="text-xs text-muted-foreground">
              Descrição opcional do perfil (máximo 255 caracteres)
            </p>
          </div>

          {/* Status */}
          <div className="flex items-center space-x-2">
            <Switch
              id="ativo"
              checked={formData.ativo}
              onCheckedChange={(checked) => setFormData({ ...formData, ativo: checked })}
            />
            <Label htmlFor="ativo">Perfil ativo</Label>
          </div>

          <div className="flex justify-end gap-2 pt-4">
            <Button type="button" variant="outline" onClick={handleClose} disabled={loading}>
              Cancelar
            </Button>
            <Button type="submit" disabled={loading}>
              {loading ? "Salvando..." : perfil ? "Atualizar" : "Criar"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default PerfilAcessoEdit;

